import { createSafeContext } from "utils/createSafeContext";

export type ThemeMode = "light" | "auto" | "dark";

type ThemeModeContextType = {
  themeMode: ThemeMode;
  setThemeMode: (mode: ThemeMode) => void;
};

export const [ThemeModeContext, useThemeModeContext] =
  createSafeContext<ThemeModeContextType>("ThemeModeContext");
